var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7403 6.09745C15.5318 8.90477 13.4003 11.1949 11.0603 11.1949C8.72025 11.1949 6.58499 8.9053 6.38023 6.09745C6.16751 3.17704 8.24161 1 11.0603 1C13.8789 1 15.953 3.23014 15.7403 6.09745Z",
    stroke: "#8B909A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1946 14.1953C6.57525 14.1953 1.88684 16.7709 1.01924 21.6322C0.914644 22.2182 1.24278 22.7805 1.84967 22.7805H20.5396C21.147 22.7805 21.4752 22.2182 21.3706 21.6322C20.5025 16.7709 15.814 14.1953 11.1946 14.1953Z",
    stroke: "#8B909A",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDropdown);
export default __webpack_public_path__ + "static/media/profileDropdown.2b76362f5079696f842d4617490e861a.svg";
export { ForwardRef as ReactComponent };